/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  realmDetailContainer: {
    overflowY: "auto",
    height: "calc(100vh - 265px)",
    padding: 0,
  },
  tabs: {
    borderTopColor: theme.palette.divider,
    borderBottomColor: theme.palette.divider,
    borderTopStyle: "solid",
    borderTopWidth: "thin",
    borderBottomStyle: "solid",
    borderBottomWidth: "thin",
    textSize: "16px",
  },
  tab: {
    fontSize: "16px",
    borderBottom: "none !important",
    color: theme.palette.text.primary,
  }
}));
